import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "YammerBootstrap" */ './lazyIndex'),
    { name: 'YammerBootstrap' }
);

// Delay loaded imports
export const lazyBootstrapYammer: LazyImport<
    typeof lazyIndex.bootstrapYammerIfNeeded,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.bootstrapYammerIfNeeded);

export { default as isYammerReady } from './selectors/isYammerReady';
